import React from 'react';
import '../ESG/ESGDesign2SignUpPage.css';
import './DevelopmentProjectsSignUpPage.css';
import {
    Box,
    TextField,
    Typography,
} from '@mui/material';
import {Image, Button as SemanticButton, Icon} from "semantic-ui-react";
import {useForm} from "../../ui/UseForm";
import {useAuthCtx} from "../../auth/AuthContextProvider";
import {CampaignSignUp} from "../signupViaCampaign.client";
import ErrorRenderer from "../../auth/ErrorRenderer";
import { DevelopmentProjectsCampaignSignUpData, DevelopmentProjectsCampaignSignUpPayload } from './DevelopmentProjectsSignup.client';
import {Link} from "react-router-dom";

export default function DevelopmentProjectsSignUpPage() {
    const {reloadAuth} = useAuthCtx()
    const { formData, handleChange, handleSubmit, submitting, error } = useForm<DevelopmentProjectsCampaignSignUpData>({
        initialState: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordAgain: '',
            status: "enabled",
            userProvidedCompanyName: '',
            campaign: "development-projects",
        },
        onSubmit: async (data) => {
            await CampaignSignUp(new DevelopmentProjectsCampaignSignUpPayload(data));
            reloadAuth()
        }
    })

    return (
        <div id={"icp4"}>
            <div className="splitContainer">
                {/* Left Side: Gradient with Branding */}
                <div className="splitLeft">
                    <div className="branding">
                        {/* Example Logo/Text for branding */}
                        <div className="logo">
                            {/*Your Brand*/}
                            <Image src={"/logos/Perl-Logo-Icon-White-2x.png"} style={{ width: 177 }} />
                        </div>
                        <h1>QuickBuild Project Qualification</h1>
                        <p>
                        Submit your C&I projects to get preliminary funding approval plus a bankable Excel Model.
                        </p>
                    </div>
                </div>

                {/* Right Side: Sign-Up Form */}
                <div className="splitRight">
                    <Box
                        component="form"
                        className="formContainer"
                        onSubmit={handleSubmit}
                    >
                        <div className="formHeader">
                            <Typography variant="h2" component="h2">
                                Sign Up
                            </Typography>
                            <Typography variant="body2">
                                Get started by creating your free account now.
                            </Typography>
                        </div>

                        {/* First Name */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                label="First Name"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                            />
                        </Box>

                        {/* Last Name */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                label="Last Name"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                            />
                        </Box>

                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                label="Company Name"
                                // inputProps={{maxLength: INPUT_FIELD_MAX_CHARACTER_LIMITS.companyName}}
                                name="userProvidedCompanyName"
                                value={formData.userProvidedCompanyName}
                                onChange={handleChange}
                            />
                        </Box>

                        {/* Business Email */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                type="email"
                                label="Business Email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </Box>

                        {/* Password */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                type="password"
                                label="Password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                            />
                        </Box>

                        {/* Confirm Password */}
                        <Box className="field">
                            <TextField
                                fullWidth
                                required
                                type="password"
                                label="Confirm Password"
                                name="passwordAgain"
                                value={formData.passwordAgain}
                                onChange={handleChange}
                            />
                        </Box>

                        <div style={{
    margin: '2rem 0',
    // padding: '2rem',
                        }}>
                    </div>
                    <SemanticButton
                        primary
                        type="submit"
                        className="raised"
                        size="huge"
                        loading={submitting}
                        disabled={submitting}
                    >
                        Get Started
                        <Icon name="arrow right" />
                    </SemanticButton>
                        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                         Already have an account?{" "}
                         <Link to="/login" className="login-link">
                             Sign in here
                         </Link>
                     </div>
                    </Box>
                </div>

                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '1rem',
                }}>
                    <ErrorRenderer error={error} />
                </div>
            </div>
        </div>
    );
}